import { PremierServiceDTO } from "./premierServiceDTO";

export class PremierPartnerDTO{
    public id!: number;
    public name!: string;
    public providerName!: string;
    public premierServiceList!: PremierServiceDTO[];
    public added!: string;
    public edited!: string;

    constructor(){
        this.premierServiceList= [];
    }
}